<smr-calendar
  [stylistID]="stylistID"
  [currentDate]="currentDate"
  [readOnlyStylistPicker]='readOnlyStylistPicker'
  [modal]="true"
  [muteEventTappability]="true"
  (onTimeSelected)="onTimeSelected($event)"
  style="height: 100%; width: 100%"
  [isModal]="isModal"
>
</smr-calendar>
